export default "__VITE_ASSET__5633ad18__"